/**
 * Status line for the graph-algorithm endpoints (/addresses/graph/pagerank, /communities, /betweenness).
 *
 * When there is nothing to compute on (no cached transactions, a graph too small) or the computation fails,
 * the backend answers `status: "not_computed"` with `engine: null`, empty results and a `reason`. It never
 * returns invented rankings or communities, so the page says "not computed" instead of naming an engine.
 */
export interface GraphAlgorithmResponse {
    engine?: string | null;
    status?: string;
    reason?: string | null;
}

export const isNotComputed = (data: GraphAlgorithmResponse | null | undefined): boolean =>
    !data || data.status === 'not_computed' || data.engine == null;

export const graphAlgorithmEngineLabel = (data: GraphAlgorithmResponse | null | undefined): string => {
    if (isNotComputed(data)) {
        const reason = data?.reason ? String(data.reason) : '';
        return reason ? `not computed (${reason})` : 'not computed';
    }
    return String(data!.engine);
};
